import { getVisibleHeight } from '@utils/browser';

import puffy from 'components/icons/puffy.png';

import { GDPRApplicationWrapper } from './styles';

function GDPRApplication({ t }) {
  const ht = getVisibleHeight() - 200;
  return (
    <GDPRApplicationWrapper ht={ht + 'px'}>
      <div>
        <img src={puffy} alt="no avatar" />
        <div>
          <h2>{t('application.gdpr.header')}</h2>
          <p>{t('application.gdpr.maintext')}</p>
        </div>
      </div>
      <div className="fake-text">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </GDPRApplicationWrapper>
  );
}

export default GDPRApplication;
